import { AxiosResponse } from "axios";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { BASE_METHODS } from "../../constants/action-types";
import { GetAllPrivacyPolicyDTO } from "../../constants/dto/privacy-policy";
import {
  setPrivacyPolicies,
  setPrivacyPolicyActionStart,
  setPrivacyPolicyErrorMessage,
} from "../../constants/reducers/privacy-policy.reducer";
import { TextEnum } from "../../constants/text";
import { timeoutError } from "../../constants/reducers/base.reducer";
import { store } from "../../store";
import { createCall } from "../base";

let body: GetAllPrivacyPolicyDTO;

export const getAllPrivacyPolicy = async () => {
  store.dispatch(setPrivacyPolicyActionStart(true));
  const { page } = store.getState().privacyPolicy;
  const queryParams = new URLSearchParams();

  queryParams.append("page", page ? page.toString() : "1");

  const request = await createCall(
    "cms/privacy-policies",
    BASE_METHODS.GET,
    "application/json",
    "1.0.0",
    undefined,
    queryParams,
  );

  try {
    const response = request as AxiosResponse;
    body = plainToClass(GetAllPrivacyPolicyDTO, response.data);
    const errors = await validate(body);
    if (errors.length > 0) {
      store.dispatch(
        setPrivacyPolicyErrorMessage(
          TextEnum.GET_ALL_PRIVACY_POLICY_INVALID_RESPONSE,
        ),
      );
      return null;
    }
    store.dispatch(
      setPrivacyPolicies({
        privacyPolicies: response.data.privacyPolicies,
        pageCount: response.data.pageCount,
      }),
    );
    return response;
  } catch (error) {
    store.dispatch(setPrivacyPolicyActionStart(false));
    store.dispatch(timeoutError());
    return null;
  }
};
